import type { AxiosResponse } from "axios";
import { axiosInstance, computeHeaders } from "./axios";
import { FieldToCropMappingNetworkResponse } from "../models/mappings";
import { CropsNetworkResponse } from "../models/crops";

/**
 * Fetch all the crops
 */
const getCrops = async ({
  authToken,
  userId,
  locale,
  region,
}: {
  authToken: string;
  userId: string;
  locale: string;
  region: string;
}): Promise<AxiosResponse<CropsNetworkResponse>> => {
  const response = await axiosInstance.request<
    never,
    AxiosResponse<CropsNetworkResponse>
  >({
    method: "GET",
    url: `/api/crops-svc/v3/crops?admin_region=${region.toUpperCase()}`,

    headers: computeHeaders({
      authToken,
      userId,
      locale,
    }),
  });

  return response;
};

const getFieldCrops = async ({
  authToken,
  userId,
  operationId,
  fakeFetch,
}: {
  authToken: string;
  userId: string;
  operationId: string;
  fakeFetch: boolean;
}): Promise<AxiosResponse<FieldToCropMappingNetworkResponse>> => {
  if (fakeFetch) {
    // Fake the payload to an empty set.
    // This is a valid state and reflects a response where no crops have been set.
    // This will prevent the app from breaking for technical reasons,
    //   but will prevent any actual use of this data
    const responsePayload = {
      data: { field_crop_info: {} },
    } as AxiosResponse<FieldToCropMappingNetworkResponse>;
    const response = Promise.resolve(responsePayload);

    return response;
  }

  const response = await axiosInstance.request<
    never,
    AxiosResponse<FieldToCropMappingNetworkResponse>
  >({
    method: "GET",
    url: "/api/scouting-api/v0/field-crop-info",
    headers: computeHeaders({
      authToken,
      userId,
      operationId,
    }),
  });

  return response;
};

export default {
  getCrops,
  getFieldCrops,
};
